import { render } from "./GamePop2.vue?vue&type=template&id=67873a6f"
import script from "./GamePop2.vue?vue&type=script&lang=js"
export * from "./GamePop2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__